import GroupDataTableRow from "./GroupDataTableRow";

export function useGroupDataRows(rowConfig) {
  return Object.fromEntries(
    Object.entries(rowConfig).map(([key, config]) => [
      key,
      GroupDataTableRow(config),
    ]),
  );
}
